import EmblaCarousel from 'embla-carousel';

// The regular overview initializer excludes these curated article sliders.
document.querySelectorAll('[data-blog-slider]').forEach(section => {
    const viewport = section.querySelector('.blog-slider-viewport');
    const nav = section.querySelector('.blog-slider-nav');
    const prev = section.querySelector('[data-blog-prev]');
    const next = section.querySelector('[data-blog-next]');
    const status = section.querySelector('[data-blog-status]');
    const slides = Array.from(viewport.querySelectorAll('.blog-location-card'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const slider = EmblaCarousel(viewport, {
        align: 'start',
        loop: false,
        // Explicit focus handling also covers partially visible cards.
        watchFocus: false,
    });
    viewport.classList.add('is-enhanced');

    function update() {
        prev.disabled = !slider.canScrollPrev();
        next.disabled = !slider.canScrollNext();
        // Keep controls visible at either end, hide only if all cards fit.
        nav.hidden = slider.scrollSnapList().length < 2;
    }

    prev.addEventListener('click', () => slider.scrollPrev(reducedMotion.matches));
    next.addEventListener('click', () => slider.scrollNext(reducedMotion.matches));
    slider.on('select', update).on('reInit', update);
    slider.on('settle', () => {
        const visible = slider.slidesInView();
        status.textContent = visible.map(index => slides[index].getAttribute('aria-label')).join(', ');
    });

    // Tabbing to an offscreen link reveals its card without moving focus.
    viewport.addEventListener('focusin', event => {
        const index = slides.findIndex(slide => slide.contains(event.target));
        if (index === -1) return;
        const registry = slider.internalEngine().slideRegistry;
        const snap = registry.findIndex(indices => indices.includes(index));
        if (snap !== -1) slider.scrollTo(snap, true);
    });
    update();
});
